import React, {useEffect, useState} from "react";
import {Modal, Button} from "react-bootstrap";
import {toast} from "react-toastify";
import { unMergeMesasByMesaId } from "../../../../../../../../../../crud/management_api/mesas";
import { X } from "react-bootstrap-icons";

interface CancelMergeProps {
  show: boolean;
  onHide: () => void;
  mesaId: number;
}

const CancelMerge: React.FC<CancelMergeProps> = ({show, onHide, mesaId}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    setIsProcessing(false);
  }, [show]);

  const handleCancelMerge = async () => {
    setIsProcessing(true);
    try {
      await unMergeMesasByMesaId(mesaId);
      toast.success("Fusión cancelada exitosamente");
      window.location.reload();
      onHide();
    } catch (error) {
      console.error("Error cancelando la fusión:", error);
      toast.error("Error cancelando la fusión");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header>
        <div className='form-modal-title-container'>
        <Modal.Title className='form-modal-title'>Cancelar fusión mesas</Modal.Title>
        </div>
                    <Button variant="none" className="modal-close-button" onClick={onHide}>
                      <X size={24} />
                    </Button>
      </Modal.Header>
      <Modal.Body>
        <p>¿Estás seguro de que deseas cancelar la fusión de las mesas?</p>
        <p>Esta acción no se puede deshacer.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isProcessing}>
          Cerrar
        </Button>
        <Button variant="danger" onClick={handleCancelMerge} disabled={isProcessing}>
          {isProcessing ? "Procesando..." : "Cancelar Fusión"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelMerge;